import React, { useState } from 'react';
import { State, StateNavProps } from './types';

const createStatesAlphabet = (states: State[]) => {
  let currentInitial: string = null;

  return states.reduce((acc, state) => {
    const stateInitial = state.name.substring(0, 1);

    if (stateInitial !== currentInitial) {
      acc.push(state);
      currentInitial = stateInitial;
    }

    return acc;
  }, []);
}

export const StateNav = ({ states }: StateNavProps) => {
  const [location, setLocation] = useState(decodeURI(window.location.hash));
  const statesAlphabet = createStatesAlphabet(states);

  return (
    <nav className="my-8 lg:mb-14 px-6 py-3 bg-cashew-dark rounded-full inline-block w-full md:w-auto overflow-scroll">
      {statesAlphabet
        .map((state, index) => (
          <a
            key={index}
            className={
              (location === `#${state.name}`) || (!location && index === 0)
                ? 'font-medium mx-3'
                : 'mx-3'
            }
            href={`#${state.name}`}
            onClick={() => setLocation(`#${state.name}`)}
          >
            {state.name.substring(0, 1)}
          </a>
        ))
      }
    </nav>
  );
};
